import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {ApiService} from '../api.service';
import {DataStorageService} from '../data-storage.service';
import {PricingService} from '../pricing.service';
import {ApiOfferService} from '../apiServices/offer/api-offer.service';

@Injectable()
export class OfferSummaryResolver implements Resolve<any> {

  constructor(private oapi: ApiOfferService,
              private api: ApiService,
              private pricing: PricingService,
              private dataStorageService: DataStorageService) {
  }

  resolve() {
    const getsArray = [];
    const offerID = this.dataStorageService.currentState.offerID;
    getsArray.push(this.oapi.getOfferOptions(offerID));
    getsArray.push(this.api.getInternet(offerID, 'CYBERLINK'));
    getsArray.push(this.api.getInternet(offerID, 'IPWORLDCOM'));
    getsArray.push(this.api.getPortedNumbers(offerID));
    getsArray.push(this.api.getNewNumbers(offerID));
    getsArray.push(this.api.getPPHosted(offerID));
    getsArray.push(this.api.getFRHosted(offerID)); // [6]
    getsArray.push(this.api.getFRSipTrunk(offerID)); // [7]
    getsArray.push(this.api.getThreeCX(offerID)); // [8]
    getsArray.push(this.api.getMsTeams(offerID)); // [9]
    getsArray.push(this.api.getPfBundle(offerID)); // [10]
    getsArray.push(this.api.getMitelHosted(offerID)); // [11]
    getsArray.push(this.api.getSipTrunk(offerID)); // [12]
    getsArray.push(this.api.getDatasim(offerID)); // [12]
    getsArray.push(this.api.getMsTeams(offerID, 'operator-connect')); // [12]
    getsArray.push(this.api.getSbcplus(offerID)); // [12]
    getsArray.push(this.api.getMobile(offerID));
    return new Promise(  (resolve, reject) => {
      const flatRateHosted = this.dataStorageService.currentState.businessFlatRateHosted;
      const flatRateSipTrunk = this.dataStorageService.currentState.businessFlatRateSipTrunk;
      const threeCX = this.dataStorageService.currentState.threeCX;

      Promise.all(getsArray).then(() => {
        let chosenType = flatRateHosted.chosenType;
        let numberOfFR = flatRateHosted.numberOfFlatRates;
        let pricingElement = this.dataStorageService.flatRateHostedPricing.filter( e => e.networkType === chosenType)[0];
        if (pricingElement) {
          flatRateHosted.monthlyCost = pricingElement.unitMonthlyCost * numberOfFR;
        } else {
          flatRateHosted.monthlyCost = flatRateHosted.unitMonthlyCost * numberOfFR;
        }

        chosenType = flatRateSipTrunk.chosenType;
        numberOfFR = flatRateSipTrunk.numberOfFlatRates;
        pricingElement = this.dataStorageService.flatRateSipTrunkPricing.filter( e => e.networkType === chosenType)[0];
        if (pricingElement) {
          flatRateSipTrunk.monthlyCost = pricingElement.unitMonthlyCost * numberOfFR;
        } else {
          flatRateSipTrunk.monthlyCost = flatRateSipTrunk.unitMonthlyCost * numberOfFR;
        }
        resolve();
      }).catch(() => reject());

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/resolvers/offerSummaryResolver.ts